import script from "./GestionBajas.vue?vue&type=script&setup=true&lang=js"
export * from "./GestionBajas.vue?vue&type=script&setup=true&lang=js"

import "./GestionBajas.vue?vue&type=style&index=0&id=23c50c82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23c50c82"]])

export default __exports__